// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Css from "bs-css/src/Css.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Theme from "../../../Theme.bs.js";
import * as React from "react";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Helpers from "../../../Helpers.bs.js";
import * as WithCss from "../../../bindings/bs-emotion-core/src/WithCss.bs.js";
import * as GatsbyImage from "gatsby-image";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

var thumb_size = 200;

var grid_item_000 = Css.width(Css.px(thumb_size));

var grid_item_001 = /* :: */[
  Css.height(Css.px(thumb_size)),
  /* :: */[
    Css.media(Theme.$$break(/* simpleGallery */588017280), /* :: */[
          Css.important(Css.display(/* none */-922086728)),
          /* [] */0
        ]),
    /* [] */0
  ]
];

var grid_item = /* :: */[
  grid_item_000,
  grid_item_001
];

function grid_item_wide(active) {
  return /* :: */[
          Css.display(active ? /* block */888960333 : /* none */-922086728),
          /* :: */[
            Css.position(/* relative */903134412),
            /* :: */[
              Css.overflow(/* hidden */-862584982),
              /* :: */[
                Css.gridColumn(1, -1),
                /* :: */[
                  Css.borderRadius(Css.px(5)),
                  /* :: */[
                    Css.media(Theme.$$break(/* simpleGallery */588017280), /* :: */[
                          Css.important(Css.display(/* block */888960333)),
                          /* [] */0
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ];
}

var thumbnail_000 = Css.display(/* block */888960333);

var thumbnail_001 = /* :: */[
  Css.overflow(/* hidden */-862584982),
  /* :: */[
    Css.position(/* relative */903134412),
    /* :: */[
      Css.top(Css.px(-4)),
      /* :: */[
        Css.left(Css.px(-4)),
        /* :: */[
          Css.width(Css.pct(100)),
          /* :: */[
            Css.height(Css.pct(100)),
            /* :: */[
              Css.border(Css.px(2), /* solid */12956715, Css.black),
              /* :: */[
                Css.backgroundColor(Css.white),
                /* :: */[
                  Css.borderRadius(Css.px(8)),
                  /* :: */[
                    Helpers.onHover(/* :: */[
                          Css.border(Css.px(2), /* dashed */568403505, Css.black),
                          /* [] */0
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var thumbnail = /* :: */[
  thumbnail_000,
  thumbnail_001
];

var label_000 = Css.position(/* absolute */-1013592457);

var label_001 = /* :: */[
  Css.width(Css.pct(100)),
  /* :: */[
    Css.height(Css.rem(2)),
    /* :: */[
      Css.lineHeight(Css.rem(2)),
      /* :: */[
        Css.left(/* zero */-789508312),
        /* :: */[
          Css.bottom(/* zero */-789508312),
          /* :: */[
            Css.color(Css.white),
            /* :: */[
              Css.backgroundColor(Css.rgba(0, 0, 0, 0.5)),
              /* :: */[
                Css.selector("& span", /* :: */[
                      Css.display(/* inlineBlock */-147785676),
                      /* :: */[
                        Css.width(Css.pct(100)),
                        /* :: */[
                          Css.textAlign(/* center */98248149),
                          /* :: */[
                            Css.verticalAlign(/* middle */-866200747),
                            /* :: */[
                              Css.fontSize(Css.rem(1.2)),
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var label = /* :: */[
  label_000,
  label_001
];

var S = {
  grid_item: grid_item,
  grid_item_wide: grid_item_wide,
  thumbnail: thumbnail,
  label: label
};

function $$Image(Props) {
  var nphoto = Props.nphoto;
  var active = Props.active;
  var onClick = Props.onClick;
  var photo = nphoto.childImageSharp;
  var name = photo.fluid.originalName;
  var name$1;
  var exit = 0;
  var idx;
  try {
    idx = $$String.index(name, /* "_" */95);
    exit = 1;
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      name$1 = name;
    } else {
      throw exn;
    }
  }
  if (exit === 1) {
    name$1 = $$String.sub(name, idx + 1 | 0, (name.length - idx | 0) - 1 | 0);
  }
  var label$1;
  var exit$1 = 0;
  var idx$1;
  try {
    idx$1 = $$String.rindex(name$1, /* "." */46);
    exit$1 = 1;
  }
  catch (exn$1){
    if (exn$1 === Caml_builtin_exceptions.not_found) {
      label$1 = name$1;
    } else {
      throw exn$1;
    }
  }
  if (exit$1 === 1) {
    label$1 = $$String.sub(name$1, 0, idx$1);
  }
  return React.createElement(WithCss.make, {
              children: (function (css) {
                  return React.createElement(React.Fragment, {
                              children: null
                            }, React.createElement("div", {
                                  className: Curry._2(css, undefined, /* :: */[
                                        grid_item,
                                        /* [] */0
                                      ]),
                                  id: photo.id,
                                  onClick: onClick
                                }, React.createElement("a", {
                                      className: Curry._2(css, undefined, /* :: */[
                                            thumbnail,
                                            /* [] */0
                                          ]),
                                      href: "#" + photo.id
                                    }, React.createElement(GatsbyImage.default, {
                                          fixed: photo.fixed
                                        }))), React.createElement("a", {
                                  className: Curry._2(css, undefined, /* :: */[
                                        grid_item_wide(active),
                                        /* [] */0
                                      ])
                                }, React.createElement(GatsbyImage.default, {
                                      fluid: photo.fluid
                                    }), React.createElement("div", {
                                      className: Curry._2(css, undefined, /* :: */[
                                            label,
                                            /* [] */0
                                          ])
                                    }, React.createElement("span", undefined, Helpers.text(label$1)))));
                })
            });
}

var border_size = 4;

var thumb_padding = 5;

var make = $$Image;

export {
  border_size ,
  thumb_padding ,
  thumb_size ,
  S ,
  make ,
  
}
/* grid_item Not a pure module */
